<template>
  <div>
    <Navbar :toReset="(url, stay, noTab) => this.reset(url, stay, noTab)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar
          active="Rawat Inap"
          :toReset="(url, stay, noTab) => this.reset(url, stay, noTab)"
        />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop">
            <div class="col-md-12">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
          </div>
          <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
          <div class="row">
            <div class="col-md-12" style="position: relative">
              <div class="mt-4">
                <FormRow
                  v-for="row in labForm"
                  v-bind:key="row.colnum + String(Math.random(1023))"
                  :row="row"
                  @handleChange="(e) => handleChange(e)"
                />
                <hr />
              </div>
              <div class="d-flex flex-between mt-4 mb-3">
                <h5 class="mb-2">Pemeriksaan Lab</h5>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-12">
                    <div class="input-group">
                      <input
                        type="text"
                        :class="
                          'form-control form-control-lg pl-5 with-icon-left without-label ' +
                            (isError ? 'error' : '')
                        "
                        placeholder="Cari kode atau nama pemeriksaan lab"
                        @input="
                          (e) => {
                            a_lab = false;
                            s_lab = e.target.value;
                            updateForm();
                          }
                        "
                        :value="s_lab"
                        v-on:keyup.enter="() => search('lab')"
                      />
                      <i
                        class="material-symbols-outlined"
                        style="margin-top: -0.25rem"
                        >search</i
                      >
                      <div class="input-group-append">
                        <button
                          class="btn btn-secondary btn-with-icon-left"
                          @click="() => search('lab')"
                        >
                          <i class="material-symbols-outlined">search</i>
                          CARI
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <SearchResult
                type=""
                @addItem="(item) => addItem(item, 'lab')"
                v-if="s_lab && a_lab"
                :loading="l_lab"
                :data="r_lab"
              />
              <table class="responsive" v-if="lab.length">
                <thead>
                  <th>KODE</th>
                  <th>NAMA PEMERIKSAAN LAB</th>
                  <th>TARIF/BIAYA</th>
                  <th>STATUS</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr
                    v-for="item in lab.filter((item) => !item.deleted)"
                    v-bind:key="item.id + Math.random(1024)"
                  >
                    <td>{{ item.kode }}</td>
                    <td>{{ item.nama }}</td>
                    <td>{{ item.formatted_biaya }}</td>
                    <td>{{ item.status }}</td>
                    <td>
                      <button
                        class="btn btn-icon btn-danger btn-sm"
                        @click="() => deleteItem('lab', item.id)"
                        v-if="item.status != 'DIBATALKAN'"
                      >
                        <i class="material-symbols-outlined">delete</i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="py-1 my-2"></div>
          <div class="card p-3">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Simpan Data Pemeriksaan Lab
                </button>
                <!-- <router-link class="btn btn-outline-danger btn-no-outline float-right text-uppercase" to="/ralan">Batalkan</router-link> -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="
                    () => reset(`/ranap/detail/${$route.params.id}?tab=lab`)
                  "
                  >Batalkan
                </a>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
import SearchResult from "@/components/SearchResult.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import {
  getTimeWithSecond,
  getInputDate,
  setPatientIntro,
  convertToRupiah,
  resetForms,
} from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import {
  dataLab,
  tindakanForm,
  labForm,
  today,
  time,
} from "@/data/RanapFormTindakan.js";

export default {
  name: "RanapFormLab",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    DetailTop,
    DetailLeft,
    Alert,
    SearchResult,
    FormRow,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: dataLab,
      tindakanForm: tindakanForm,
      labForm: labForm,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      saveSuccess: false,
      saveFailed: false,
      formSet: {
        no_rawat: "",
        id_dokter: "",
        id_petugas: "",
        id_petugas_lab: "",
        lab_type: "Dewasa",
        tgl_tindakan: today,
        jam_tindakan: time,
      },
      n: 0,
      s_lab: "",
      s_doc: "",
      s_nrs: "",
      s_both: "",
      r_lab: [],
      r_doc: [],
      r_nrs: [],
      r_both: [],
      lab: [],
      doc: [],
      nrs: [],
      both: [],
      a_lab: false,
      a_doc: false,
      a_nrs: false,
      a_both: false,
      l_lab: false,
      l_doc: false,
      l_nrs: false,
      l_both: false,
      isError: false,
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        // let date = getInputDate();
        // let today = new Date();
        // let time = getTimeWithSecond(today.getHours(),today.getMinutes(),today.getSeconds());
        // let today = + new Date();

        //console.log(this.lab);
        let labs =
          this.lab && this.lab.length
            ? [...this.lab]
                .filter((item) => !(item.deleted && !item.id_ralan_lab))
                .map((item) => {
                  return {
                    operation: item.deleted ? "delete" : null,
                    no_rawat: self.formSet["no_rawat"],
                    id_petugas: self.formSet["id_petugas_lab"],
                    id_periksa_lab: item.id,
                    biaya: item.biaya,
                    kategori: self.formSet["lab_type"],
                  };
                })
            : [];
        //console.log(labs);
        if (labs && labs.length) {
          try {
            let resultLab = await this.$store.state.HTTP_JSON.post(
              `/ranap/pemeriksaan/lab-bulk`,
              { labs: labs }
            );
            //console.log(resultLab);
            if (!resultLab || resultLab.status != 200) {
              this.saveFailed = true;
              this.saveSuccess = false;
              this.checkSuccess();
              return;
            }
          } catch (e) {
            //console.log(e);
            this.saveFailed = true;
            this.saveSuccess = false;
            this.checkSuccess();
            return;
          }
        }
        this.checkSuccess();
      } else {
        //console.log(valid);
      }
    },
    handleFormOld: async function() {
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        // Object.keys(this.formSet).forEach(function(key) {
        //     formData.append(key, self.formSet[key]);
        // });
        //console.log({lab:this.lab,nrs:this.nrs,doc:this.doc,both:this.both});
        self.n =
          this.lab.filter((item) => !(item.deleted && !item.id_ralan_lab))
            .length +
          this.doc.filter((item) => !(item.deleted && !item.id_ralan_tindakan))
            .length +
          this.nrs.filter((item) => !(item.deleted && !item.id_ralan_tindakan))
            .length +
          this.both.filter((item) => !(item.deleted && !item.id_ralan_tindakan))
            .length;

        this.lab.forEach(async function(item) {
          //n-=1;

          if (!item.deleted && item.status != "DIBATALKAN") {
            let body = `no_rawat=${self.formSet["no_rawat"]}&id_petugas=${self.formSet["id_petugas_lab"]}&id_periksa_lab=${item.id}&kategori=${self.formSet.lab_type}&biaya=${item.biaya}`;
            if (!item.id_ralan_lab) {
              self.saveLab(body);
            } else {
              self.saveLab(body, item.id_ralan_lab);
            }
          } else {
            if (item.id_ralan_lab && item.status != "DIBATALKAN") {
              //console.log('\n');
              //console.log(item.deleted);
              //console.log(item.status);
              //console.log('\n');
              self.deleteLab(item.id_ralan_lab);
            }
          }
        });
      } else {
        //console.log(valid);
      }
    },
    async saveLab(body, id) {
      try {
        if (id) {
          //console.log(body);
          let result = await this.$store.state.HTTP_ENC.put(
            `ranap/pemeriksaan/lab/${id}`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        } else {
          let result = await this.$store.state.HTTP_ENC.post(
            `ranap/pemeriksaan/lab`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        }
      } catch (e) {
        ////console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    async deleteLab(id) {
      try {
        //console.log(`ranap/pemeriksaan/lab/${id}`);
        let result = await this.$store.state.HTTP_ENC.delete(
          `ranap/pemeriksaan/lab/${id}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.n = this.n - 1;
          if (this.n == 0) {
            this.checkSuccess();
          }
        }
      } catch (e) {
        ////console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
          that.reset(`/ranap/detail/${that.$route.params.id}?tab=lab`);
        }, 1000);
      }
    },
    reset(url, stay, noTab) {
      // if (this.validated) {
      resetForms(this.formSet, [this.labForm], true, this.handleChange);
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (this.fromUrl && fromTab) {
          let queryString = noTab ? "" : "?tab=" + fromTab;

          ////console.log(backBtn)
          this.$router.push({ path: backBtn + queryString });
        } else {
          ////console.log(window.history);
          if (backBtn) {
            this.$router.push({ path: backBtn });
          } else {
            this.$router.go(-1);
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = noTab ? "" : "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
        //console.log(e.target.name);
        //console.log(this.formSet[e.target.name]);
      }
      if (e.target.name == "lab_type") {
        let self = this;
        self.lab = self.lab.map(function(item) {
          //console.log(item);
          if (item.id_ralan_lab) {
            if (self.formSet["lab_type"] == "Dewasa") {
              item.biaya = item.periksalab.biaya_dewasa;
              item.formatted_biaya = item.periksalab.formatted_biaya_dewasa;
            } else {
              item.biaya = item.periksalab.biaya_anak;
              item.formatted_biaya = item.periksalab.formatted_biaya_anak;
            }
          } else {
            if (self.formSet["lab_type"] == "Dewasa") {
              item.biaya = item.biaya_dewasa;
            } else {
              item.biaya = item.biaya_anak;
            }
            item.formatted_biaya = convertToRupiah(item.biaya);
          }
          return item;
        });
      }
      this.updateForm();
      //console.log(this.formSet);
    },

    updateForm() {
      // this.tindakanForm[0].columns[0].value=String(this.formSet['tgl_tindakan']);
      // this.tindakanForm[0].columns[1].value=String(this.formSet['jam_tindakan']);
      // this.tindakanForm[0].columns[2].value=String(this.formSet['id_petugas']);
      // this.tindakanForm[0].columns[3].value=String(this.formSet['id_dokter']);
      this.labForm[0].columns[0].value = String(this.formSet["id_petugas_lab"]);
      this.labForm[0].columns[1].value = this.formSet["lab_type"];
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [this.labForm].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      //   this.tindakanForm = forms[0];
      this.labForm = forms[0];
      //console.log(self.formSet);
      return valid;
    },
    fetchLab: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `ranap/pemeriksaan/lab?no_rawat=${this.formSet["no_rawat"]}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          self.lab = [];
          result.data.data
            .filter((item) => item.status != "DIBATALKAN")
            .forEach((item) => {
              //console.log(item.id);
              //console.log(item);
              item.nama = item.periksalab.nama;
              item.kode = item.periksalab.kode;
              item.id_ralan_lab = item.id;
              //console.log(item.id_ralan_lab);
              item.id = item.periksalab.id;
              self.lab = self.lab.concat(item);
            });
          console.log(self.lab);
          if (result.data.data.length) {
            self.formSet.id_petugas_lab = String(
              result.data.data[0].id_petugas
            );
            labForm[0].columns[0].value = self.formSet.id_petugas_lab;
            self.formSet.lab_type = result.data.data[0].kategori;
            labForm[0].columns[1].value = self.formSet.lab_type;
          }
          //console.log(self['formSet']);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        //console.log(result);
        if (result.status == "200") {
          let nurses = result.data.data.map((item) => {
            return { value: item.id, label: item.nama };
          });

          this.tindakanForm[0].columns[2].options = nurses;
          this.labForm[0].columns[0].options = nurses;
          if (!this.formSet.id_petugas_lab) {
            this.formSet.id_petugas_lab =
              this.$store.state.id_petugas_lab || "";
            if (this.formSet.id_petugas_lab) {
              this.labForm[0].columns[0].value = this.formSet.id_petugas_lab;
            }
          }
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },

    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result.data);
          let doctors = result.data;
          //console.log(doctors);
          this.tindakanForm[0].columns[3].options = doctors.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          this.tindakanForm[0].columns[3].value = this.formSet.id_dokter;
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    search: async function(type) {
      //console.log(type);
      this["a_" + type] = true;
      this["l_" + type] = true;

      let url;
      if (type == "lab") {
        url = "periksalab";
      } else {
        url = "tindakan";
      }
      try {
        let result = await this.$store.state.HTTP.get(
          `${url}?q=${this["s_" + type]}`
        );
        //console.log(result);
        if (result.status == "200") {
          // this['r_'+type]=result.data;
          let self = this;
          this["r_" + type] = result.data.map(function(item) {
            if (type == "lab") {
              item.biaya =
                self.formSet.lab_type == "Dewasa"
                  ? item.biaya_dewasa
                  : item.biaya_anak;
            }
            item.formatted_biaya = convertToRupiah(item.biaya);
            return item;
          });
          //console.log(this['r_'+type]);
          self["l_" + type] = false;
        } else {
          this["r_" + type] = [];
          self["l_" + type] = false;
        }
      } catch (e) {
        this["r_" + type] = [];
        this["l_" + type] = false;
      }
    },
    addItem: async function(item, type) {
      let exist = false;
      this[type].map((el) => {
        if (el.id == item.id) {
          exist = true;
          if (el.deleted) {
            el.deleted = false;
          }
        }
        return el;
      });
      if (!exist) {
        this[type].push(item);
      }
      this["r_" + type] = [];
      this["s_" + type] = "";
      this["a_" + type] = false;
      //console.log(this[type]);
    },
    deleteItem: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
        }
        return item;
      });
      //console.log(this[type]);
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `ranap/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          // this.rows = result.data;
          //console.log(this.rows);
          let dataPasien = result.data.pasien;
          //console.log(dataPasien);
          let ranap = result.data;
          //console.log(this.detailTop);

          let ralan = result.data.ralan;
          this.idRalan = ralan.id;
          this.darurat = ralan.darurat;
          this.no_rawat = ranap.no_rawat;
          this.formSet.no_rawat = ranap.no_rawat;
          //console.log(ralan);
          this.detailTop = setPatientIntro(dataPasien);
          this.detailLeftTop = [
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "No. Registrasi   |    No. Rawat",
                  content: ralan.formatted_no_reg_rawat,
                  icon: "confirmation_number",
                  colwidth: 4,
                },
                {
                  label: "Kamar Inap",
                  content:
                    ranap.kamar_ranap.nama +
                    " | " +
                    ranap.kamar_ranap.formatted_kelas,
                  icon: "hotel",
                  colwidth: 4,
                },
                {
                  label: "Nomor Kasur",
                  content: ranap.kamar_ranap.formatted_no_kasur,
                  icon: "radio_button_checked",
                  colwidth: 4,
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "Waktu Check In",
                  content:
                    ranap.formatted_tgl_masuk + " " + ranap.formatted_jam_masuk,
                  icon: "apps",
                  colwidth: 4,
                },
                {
                  label: "Dokter yang Dituju",
                  content: ranap.dokter.formatted_nama,
                  icon: "person_pin",
                  colwidth: 4,
                },
                {
                  label: "Petugas Penanggung Jawab",
                  content: ranap.petugas.nama,
                  icon: "apps",
                  colwidth: 4,
                },
              ],
            },
          ];
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
      this.fetchNurses();
      this.fetchDoctors();
      //   this.fetchTindakan();
      this.fetchLab();
    },
    handlePopstate(event) {
      console.log("going in");
      this.reset(
        `/ranap/detail/${this.$route.params.id}?tab=lab`,
        false,
        false
      );
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    let url = `/ranap/detail/${this.$route.params.id}?tab=lab`;
    this.data.backBtn = url;
    this.data.toReset = (url, stay, noTab) => this.reset(url, stay, noTab);
    this.data.breadcrumb[1].link = url;
    this.displayData();
  },
  created() {
    window.addEventListener("popstate", (event) => this.handlePopstate(event));
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("popstate", (event) =>
      this.handlePopstate(event)
    );
    next();
  },
};
</script>
